/**
 * Created by rak on 8/24/2018.
 */
/**
 * Created by rak on 3/24/2016.
 */
'use strict';

angular.module('betosyswebapp')
  .controller('TachoHistoryCtrl', function ($rootScope, $scope, AuthenticationService, base64, localStorageService, $translate, commonTrackService, dashboardService, customerService) {
    $scope.pageHeader = 'Driver Dashboard';

    var loginID = AuthenticationService.GetLoginID();

    //dash board
    $scope.username = loginID.username;
    $scope.dashBoardName = 'dashBoard.TachoHistoryDashboard.' + $scope.username;
    var model = localStorageService.get($scope.dashBoardName);

    if (!model) {
      model = customerService.getTachoHistoryDashboardConfig(commonTrackService.getViewPortName());
    }


    $scope.dashBoardModel = model;
    $scope.collapsible = true;
    $scope.maximizable = true;

    $scope.widgetFilter = function (widget, type) {
      if (!isExculdedParentWidget(type) && (widget.isSingleInstance === undefined || notExist(type))) {
        return type;
      }
    };

    var isExculdedParentWidgetArr = ['vehicleListWidget', 'FMSVehicleWidget', 'DriverWrkHrsWidget', 'fleetMapWidget', 'tachoDownloadStatusWidget'];

    function isExculdedParentWidget(type) {
      for (var j = 0; j < isExculdedParentWidgetArr.length; j++) {
        if (type === isExculdedParentWidgetArr[j]) {
          return true;
        }
      }
      return false;
    }

    function notExist(type) {
      return !dashboardService.getDashboardWidget($scope.dashBoardModel, type);
    }

    var adfDashboardChangedEvnt = $scope.$on('adfDashboardChanged', function (event, name, model) {
      localStorageService.set(name, model);
    });

    var rowSelectedEvnt = $scope.$on('rowSelected', function (event, data) {
      if (data.selectedRow) {
        commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, commonTrackService.getVehicleBasedWidgetNameArray(), data.selectedRow.devicedesc);
      } else {
        commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, commonTrackService.getVehicleBasedWidgetNameArray(), null);
      }
    });


    var tachoDetailWidgtEvet = $scope.$on('tacho_detail_widget_event', function (event, data) {
      if (data.eventType === 'date_change') {
        commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, [{
          name: 'tachoEventDetailWidget',
          titleTranslationKey: 'dashBoard.fleetManagement.tachoEventDetail.tachoEventDetailTitle'
        }], data.date);
        //data
      } else if (data.eventType === 'tacho_event_history_table_row_select' || data.eventType === 'working_hours_row_select') {
        commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, [{
          name: 'DriverWrkHrsSVGWidget',
          titleTranslationKey: 'dashBoard.fleetManagement.driverWhrkHrsSVG.title'
        }, {
          name: 'DriverDigitalTachoStatusWidget',
          titleTranslationKey: 'dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'
        }], data.date);

        if (data.selectedRow) {
          commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, [{
            name: 'vehicleMapWidget',
            titleTranslationKey: 'dashBoard.fleetManagement.deviceMap.deviceMapTitle'
          }, {
            name: 'vehicleDetailsWidget',
            titleTranslationKey: 'dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle'
          }, {
            name: 'TempMonitoringWidget',
            titleTranslationKey: 'dashBoard.fleetManagement.tempMonitoringWidget.title'
          }], data.selectedRow.devicedesc);
        }
        // update drive name
        commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, [{
          name: 'tachoEventDetailWidget',
          titleTranslationKey: 'dashBoard.fleetManagement.tachoEventDetail.tachoEventDetailTitle'
        }], data.date + ' / ' + data.selectedRow.driverdesc);
      }
    });

    $scope.$on('$destroy', function () {
      rowSelectedEvnt();
      adfDashboardChangedEvnt();
      tachoDetailWidgtEvet();
    }
    );
  });



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/tachoHistoryDashboard/tachoHistoryDashboardController.js